import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Drawer, List, ListItem, ListItemText, IconButton, Typography, Collapse, Box, Avatar, Menu, MenuItem, ListItemIcon, Divider, Tooltip, Dialog, DialogContent, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BuildIcon from '@mui/icons-material/Build';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Logout from '@mui/icons-material/Logout';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import { local_url } from './Const';
// Styled components
const DrawerHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  padding: '16px',
  backgroundColor: '#004d00',
  color: '#ffffff',
  justifyContent: 'space-between',
  borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
  borderRadius: '4px 4px 0 0',
}));

const StyledListItem = styled(ListItem)(({ active }) => ({
  '&:hover': {
    backgroundColor: '#6b8e23',
    cursor: 'pointer',
  },
  backgroundColor: active ? '#005600' : 'transparent',
  borderRadius: '4px',
  transition: 'background-color 0.3s ease',
}));

const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  '& .MuiListItemText-primary': {
    fontWeight: 'bold',
    color: 'black',
  },
}));



const CenteredToolbar = styled(Toolbar)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 16px',
});

const screenTitles = {
  '/CustomerLedger': 'Customer Ledger',
  '/ledgerScreen': 'Customer Ledger',
  '/balanceledger': 'Ledger Balance',
  '/allotorder': 'Order Change Request',
  '/CreditNoteCreate': 'Credit Note Create',
  '/GTStockMovement': 'GT Stock Movement',
  '/GTOrderMove': 'GT Order Movement Report',
  '/BranchDayRateReport': 'Todays Day Rate',
  '/RateTrends': 'Last Update Rate Trends Report',
  '/CreditNoteApprove': 'Credit Note Approve',
  '/AgeingLedger': 'Credit Ageing',
  '/saleorderreport': 'Order Report',
  '/SaleOrderItemReport': 'Item Report',
  '/UserProfile': 'User Profile',
  '/Login': 'Login',
  '/B2CSales': 'B2C Sales',
  '/B2BSales': 'B2B Sales',
  '/SaleSummary': 'Sale Summary',
  '/SaleWeeklySummary': 'Sale Weekly Summary',
  '/RateUpload': 'Rate Upload',
  '/PromoCode': 'Promo Code',
  '/DayRates': 'Day Rates Upload',
  '/HORECA': 'HORECA',
  '/EAN': 'EAN',
  '/VANRate': 'VAN Rate',
  '/HORECARate': 'HORECA Rate',
  '/HorecaFixRate': 'Horeca Fix Rate',
  '/SaleOrderChangeReport': 'Order Change Request Report',
  '/IndentDetailListing': 'Indent Detail Listing Report',
  '/Transfers': 'Transfers',
  '/Stock_EOD': 'Stock EOD',
  '/Near_Expiry': 'Near Expiry',
  '/Wastage_Report': 'Wastage Report',
  '/JobWorkComponent': 'Job Work',
  '/BillSettlement': 'Bill Settlement',
  '/company-list': 'Company Management',
  '/DriverList': 'User Management',
  '/discounts': 'Discount Management',
  '/dashBoard': 'Dashboard',
  '/discountScheduleList': 'Discount Schedule',
  '/HorecaStock': 'Horeca Stock',
  '/HorecaReport': 'Horeca Report',
  '/HorecaMultipleCustomer': 'Horeca Multiple Customer',
  '/Posdayend': 'POS Day End',
  '/BatchRate': 'Batch Rate',
  '/PypOrders': 'PYP Orders',
  '/PYPReport': 'PYP Report',
  '/OnlineOrderCollections': 'Online Order Collections',
  '/HorecaCustomerRateReport': 'Horeca Customer Rate Report',
  '/SaleReport': 'Sale Report',
  '/ItemMasterIndent': 'Item Master Indent',
  '/OrderItemDetail': 'Order Item Details',
  '/SaleItemDetail': 'Sale Item Detail',
  '/SaleOrderReportNew': 'Sale Bill Report',
  '/HorecaProController': 'Horeca New Rate Upload',
  '/BOMMaster': 'BOM Master',
  '/BomByproduct': 'BOM Byproduct',
  '/PoReport': 'Group Company Report',
  '/ApprovalReport': 'Approval Report',
  '/FeedbackDashboard': 'Feedback Dashboard',
  '/WalletReport': 'Wallet Report POS',
  '/CustomerWalletLedger': 'Customer Wallet Ledger',
  '/WalletLedger': 'Wallet Ledger',
  '/AdminQRCoupon': 'Admin QR Coupon',

};



const menuItemIcons = {
  A: <ShoppingCartIcon />,
  B: <AssessmentIcon />,
  C: <BuildIcon />,
  D: <ExitToAppIcon />,
};

export const Header = () => {
  const userRole = localStorage.getItem('userRole');
  const userId = localStorage.getItem('userId');
  const [activeDropdowns, setActiveDropdowns] = useState([]);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeMenuItem, setActiveMenuItem] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const currentScreenTitle = screenTitles[location.pathname] || 'IB Retail';

  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await fetch(`${local_url}/api/GenMenu/REP1/${userId}/${userRole}`);
        const data = await response.json();
        setMenuItems(data);
      } catch (error) {
        console.error('Error fetching menu items:', error);
      }
    };
    fetchMenuItems();
  }, []);

  const toggleDropdown = (menuCode) => {
    setActiveDropdowns((prev) =>
      prev.includes(menuCode) ? prev.filter((code) => code !== menuCode) : [...prev, menuCode]
    );
  };

  const toggleDrawer = () => setIsDrawerOpen(!isDrawerOpen);

  const handleMenuItemClick = (formName, menuName) => {
    console.log(`Menu item clicked: ${menuName}, formName: ${formName}`);
    setActiveDropdowns([]);
    setIsDrawerOpen(false);
    setActiveMenuItem(formName);

    if (menuName === "Customer Ledger") {
      console.log('Redirecting to /ledgerScreen');
      navigate("/ledgerScreen");
    } else if (menuName === "Ledger Balance") {
      console.log('Redirecting to /balanceledger');
      navigate("/balanceledger");
    } else if (formName === "WebReassignControllor") {
      console.log('Redirecting to /allotorder');
      navigate("/allotorder");
    } else if (formName === "CreditNoteCreateController") {
      console.log('Redirecting to /CreditNoteCreate');
      navigate("/CreditNoteCreate");
    } else if (formName === "GTStockMoveController") {
      console.log('Redirecting to /GTStockMovement');
      navigate("/GTStockMovement");
    } else if (formName === "GTOrderMoveController") {
      console.log('Redirecting to /GTOrderMove');
      navigate("/GTOrderMove");
    } else if (formName === "BranchDayRateReportController") {
      console.log('Redirecting to /BranchDayRateReport');
      navigate("/BranchDayRateReport");
    } else if (formName === "RateTrendsController") {
      console.log('Redirecting to /RateTrends');
      navigate("/RateTrends");
    }
    else if (formName === "VANRateController") {
      console.log('Redirecting to /VANRate');
      navigate("/VANRate");
    }
    else if (formName === "HorecaRateController") {
      console.log('Redirecting to /HorecaRate');
      navigate("/HORECARate");
    }
    else if (formName === "HorecaCustomerRateReportController") {
      console.log('Redirecting to /HorecaCustomerRateReport');
      navigate("/HorecaCustomerRateReport");
    }
    else if (formName === "CreditNoteApproveController") {
      console.log('Redirecting to /CreditNoteApprove');
      navigate("/CreditNoteApprove");
    } else if (menuName === "Credit Ageing") {
      console.log('Redirecting to /AgeingLedger');
      navigate("/AgeingLedger");
    } else if (menuName === "B2C Sales") {
      console.log('Redirecting to /B2CSales');
      navigate("/B2CSales");

    } else if (formName === "B2BSalesContoller") {
      console.log('Redirecting to /B2CSales');
      navigate("/B2BSales");

    }
    else if (menuName === "Sale Summay") {
      console.log('Redirecting to /SaleSummary');
      navigate("/SaleSummary");

    }
    else if (formName === "PromoSchemeContoller") {
      console.log('Redirecting to /Promo Scheme');
      navigate("/PromoCode");

    }
    else if (menuName === "SaleWeeklySummay") {
      console.log('Redirecting to /SaleWeeklySummary');
      navigate("/SaleWeeklySummary");

    } else if (menuName === "Order Report") {
      console.log('Redirecting to /saleorderreport');
      navigate("/saleorderreport");
    }
    else if (menuName === "Company") {
      console.log('Redirecting to /company-list');
      navigate("/company-list");
    }
    else if (menuName === "User") {
      console.log('Redirecting to /DriverList');
      navigate("/DriverList");
    }
    else if (formName === "ChannelRates") {
      console.log('Redirecting to /RateUpload');
      navigate("/RateUpload");
    }

    else if (formName === "DayRates") {
      console.log('Redirecting to /DayRates');
      navigate("/DayRates");
    }

    else if (formName === "HORECA") {
      console.log('Redirecting to /HORECA');
      navigate("/HORECA");
    }

    else if (formName === "EANControllor") {
      console.log('Redirecting to /EAN');
      navigate("/EAN");
    }

    else if (formName === "PYPController") {
      console.log('Redirecting to /PYPReport');
      navigate("/PYPReport");
    }
    else if (formName === "PypOrders") {
      console.log('Redirecting to /PypOrders');
      navigate("/PypOrders");
    }
    else if (formName === "OnlineOrderCollections") {
      console.log('Redirecting to /OnlineOrderCollections');
      navigate("/OnlineOrderCollections");
    }
    else if (menuName === "Item Report") {
      console.log('Redirecting to /SaleOrderItemReport');
      navigate("/SaleOrderItemReport");
    }



    else if (formName === "DailyRateUploadController") {
      console.log('Redirecting to /DailyRateUpload');
      navigate("/DailyRateUpload");
    }

    else if (formName === "DiscountMasterContoller") {
      console.log('Redirecting to /discounts');
      navigate("/discounts");
    }

    else if (formName === "OrderDetailedController") {
      console.log('Redirecting to /OrderItemDetail');
      navigate("/OrderItemDetail");
    }


    else if (formName === "DashBoardController") {
      console.log('Redirecting to /DashBoard');
      navigate("/dashBoard");
    }
    else if (formName === "DiscountScheduleContoller") {
      console.log('Redirecting to /discountScheduleList');
      navigate("/discountScheduleList");
    }

    else if (formName === "ChangeRequestController") {
      console.log('Redirecting to /SaleOrderItemReport');
      navigate("/SaleOrderChangeReport");

    }

    else if (formName === "HorecaStockController") {
      console.log('Redirecting to /SaleOrderItemReport');
      navigate("/HorecaStock");

    }

    else if (formName === "HorecaReport") {
      console.log('Redirecting to /SaleOrderItemReport');
      navigate("/HorecaReport");

    }

    else if (formName === "HorecaReport") {
      console.log('Redirecting to /SaleOrderItemReport');
      navigate("/HorecaReport");

    }

    else if (formName === "HorecaMultipleCustomer") {
      console.log('Redirecting to /HorecaMultipleCustomer');
      navigate("/HorecaMultipleCustomer");

    }

    else if (formName === "HorecaCustController") {
      console.log('Redirecting to /HorecaFixRate');
      navigate("/HorecaFixRate");

    }



    else if (formName === "TransfersController") {
      console.log('Redirecting to /Transfers');
      navigate("/Transfers");

    }

    else if (formName === "SaleReportController") {
      console.log('Redirecting to /SaleReport');
      navigate("/SaleReport");

    }


    else if (formName === "IndentListingController") {
      console.log('Redirecting to /IndentDetailListing');
      navigate("/IndentDetailListing");

    }

    else if (formName === "SaleItemDetailController") {
      console.log('Redirecting to /SaleItemDetail');
      navigate("/SaleItemDetail");
    }


    else if (formName === "JobWorkController") {
      console.log('Redirecting to /JobWork');
      navigate("/JobWorkComponent");

    }
    else if (formName === "SaleBillController") {
      console.log('Redirecting to /SaleOrderReportNew');
      navigate("/SaleOrderReportNew");

    }
    else if (formName === "POSDayEndController") {
      console.log('Redirecting to /Posdayend');
      navigate("/Posdayend");

    }

    else if (formName === "WastageReportController") {
      console.log('Redirecting to /Wastage_Report');
      navigate("/Wastage_Report");
    }

    else if (formName === "NearExpiryController") {
      console.log('Redirecting to /Near_Expiry');
      navigate("/Near_Expiry");
    }



    else if (formName === "BatchRateController") {
      console.log('Redirecting to /BatchRate');
      navigate("/BatchRate");
    }

    else if (formName === "StockCashEODController") {
      console.log('Redirecting to /Stock_EOD');
      navigate("/Stock_EOD");

    }

    else if (formName === "BillSettlementController") {
      console.log('Redirecting to /BillSettlement');
      navigate("/BillSettlement");

    }
    else if (formName === "ItemMasterController") {
      console.log('Redirecting to /ItemMasterIndent');
      navigate("/ItemMasterIndent");

    }

    else if (formName === "OrderConsolidationController") {
      console.log('Redirecting to /OrderConsolidation');
      navigate("/OrderConsolidation");
    }


    else if (formName === "CustomerWalletLedgerController") {
      console.log('Redirecting to /CustomerWalletLedger');
      navigate("/CustomerWalletLedger");

    }
    else if (formName === "AdminQRCouponController") {
      console.log('Redirecting to /AdminQRCoupon');
      navigate("/AdminQRCoupon");
    }


    else if (formName === "HorecaProController") {
      console.log('Redirecting to /HorecaUploadPro');
      navigate("/HorecaUploadPro");

    }
    else if (formName === "BomMasterController") {
      console.log('Redirecting to /BomMaster');
      navigate("/BomMaster");

    }
    else if (formName === "BomByproductController") {
      console.log('Redirecting to /BomByproduct');
      navigate("/BomByproduct");

    }
    else if (formName === "GCReportController") {
      console.log('Redirecting to /PoReport');
      navigate("/PoReport");

    }
    else if (formName === "ApprovalReportController") {
      console.log('Redirecting to /ApprovalReport');
      navigate("/ApprovalReport");

    }
    else if (formName === "FeedbackDashboardController") {
      console.log('Redirecting to /FeedbackDashboard');
      navigate("/FeedbackDashboard");
    }
    else if (formName === "WalletReportController") {
      console.log('Redirecting to /WalletReport');
      navigate("/WalletReport");
    }
    else if (formName === "CustomerWalletLedgerController") {
      console.log('Redirecting to /CustomerWalletLedger');
      navigate("/CustomerWalletLedger");
    }
    else if (formName === "WalletLedgerController") {
      console.log('Redirecting to /WalletLedger');
      navigate("/WalletLedger");
    }

    else if (menuName === "Exit") {
      console.log('Redirecting to /login');
      localStorage.clear();
      sessionStorage.clear();
      navigate("/Login");
    }
  };

  const renderMenuItem = (item, level = 0) => (
    <React.Fragment key={item.menuCode}>
      <StyledListItem
        onClick={() => item.childMenu.length > 0 ? toggleDropdown(item.menuCode) : handleMenuItemClick(item.formName, item.menuName)}
        style={{ paddingLeft: `${level * 16 + 16}px` }}
        active={activeMenuItem === item.formName}
      >
        {menuItemIcons[item.menuCode] && <span style={{ marginRight: 8 }}>{menuItemIcons[item.menuCode]}</span>}
        <StyledListItemText primary={item.menuName} />
        {item.childMenu.length > 0 && (activeDropdowns.includes(item.menuCode) ? <ExpandMoreIcon /> : <ChevronRightIcon />)}
      </StyledListItem>
      {item.childMenu.length > 0 && (
        <Collapse in={activeDropdowns.includes(item.menuCode)} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {item.childMenu.map((subItem) => renderMenuItem(subItem, level + 1))}
          </List>
        </Collapse>
      )}
    </React.Fragment>
  );

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleProfile = () => {
    setAnchorEl(null);
    navigate('/UserProfile');
  };
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/Login');
  };
  const handleOpenModal = () => {
    setOpenModal(true);
    handleClose();
  };
  const handleCloseModal = () => setOpenModal(false);
  const handleChangeRole = (role) => {
    console.log(`Role changed to: ${role}`);
    handleCloseModal();
  };

  return (
    <>
      <AppBar position="static" style={{ backgroundColor: '#004D00', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.3)' }}>
        <CenteredToolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer}
            sx={{ flexBasis: '48px' }}
          >
            <MenuIcon />
          </IconButton>

          <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1 }}>
            <Typography
              variant="h6"
              component="div"
              sx={{
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: isMobile ? '1.1rem' : '1.25rem'
              }}
            >
              {currentScreenTitle}
            </Typography>
          </Box>


          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{
                flexBasis: '48px',
                '& .MuiAvatar-root': {
                  width: isMobile ? 28 : 32,
                  height: isMobile ? 28 : 32,
                  bgcolor: 'white',
                  color: 'darkgreen'
                },
              }}
              aria-controls={anchorEl ? 'account-menu' : undefined}
              aria-haspopup="true"
            >
              <Avatar>M</Avatar>
            </IconButton>
          </Tooltip>
        </CenteredToolbar>
      </AppBar>

      {/* Keep the rest of the component unchanged */}
      <Drawer anchor="left" open={isDrawerOpen} onClose={toggleDrawer}>
        <DrawerHeader>
          <Typography variant="h6">IB Retail</Typography>
          <IconButton color="inherit" onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
        </DrawerHeader>
        <List>{menuItems.map((item) => renderMenuItem(item))}</List>
      </Drawer>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 28,
                height: 28,
                ml: -0.5,
                mr: 1,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem onClick={handleProfile}>
          <Avatar /> Profile
        </MenuItem>
        <MenuItem onClick={handleOpenModal}>
          <Avatar /> Change Role
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>

      <Dialog open={openModal} onClose={handleCloseModal} fullWidth maxWidth="xs">
        <DialogContent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(2),
          }}
        >
          <Typography variant="h5" gutterBottom>
            Select Your Role
          </Typography>
          <Button variant="contained" onClick={() => handleChangeRole('Manager')}>
            Role Manager
          </Button>
          <Button variant="contained" onClick={() => handleChangeRole('Assistant')}>
            Assistant
          </Button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Header;
